import {
  registerCand,
  canRegister,
  googleLinkedInLogin,
  userAccess,
  sendCandOtp,
  sendCandOtp as sendOtp,
  checkCandOtp,
  resetPassword,
  checkCandidateDirect,
  getUserParser,
  checkAndSendOTP,
  checkCandidateSignin,
  getCandidateOnboard,
} from "@/utils/apiFunctions";
import { eventBus } from "@/utils/eventBus";
import {
  clearAllCookiesExceptGuest,
  setRefreshToken,
  getGuestUUID,
  clearGuestUUID,
} from "@/utils/tokenCheck";
import {
  required,
  email,
  maxLength,
  helpers,
  requiredIf,
  numeric,
  minLength,
} from "vuelidate/lib/validators";
import { debounce } from "lodash";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { setToken } from "../../utils/tokenCheck";
import { getProcessedToken } from "@/utils/request";
import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from "intl-tel-input";
import { COOKIE_OPTIONS_SUFFIX } from "../cookieConfig";
import { appConfig } from "@/config/appConfig";
const qs = require("qs");
const sign = require("jwt-encode");

function googleAuthCodeLogin() {
  return new Promise((resolve, reject) => {
    const initAndRequest = () => {
      window.google.accounts.oauth2
        .initCodeClient({
          client_id: process.env.VUE_APP_CLIENT_ID,
          scope: "email profile openid",
          ux_mode: "popup",
          callback: (response) => {
            response.code ? resolve(response) : reject(response);
          },
          error_callback: (err) => reject(err),
        })
        .requestCode();
    };
    if (window.google && window.google.accounts) {
      initAndRequest();
    } else {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      script.onload = initAndRequest;
      script.onerror = () =>
        reject(new Error("Failed to load Google Identity Services"));
      document.head.appendChild(script);
    }
  });
}

export default {
  name: "LoginPage",
  props: {
    userTypeProp: {
      type: String,
      default: "candidate",
    },
  },
  data() {
    return {
      redirectUrl: null,
      windowWidth: window.innerWidth,
      incomingMode: null,
      incomingUserType: null,
      isOpen: false,
      overlayOpacity: 0.46,
      mode: "login",
      userType: this.userTypeProp,
      showBusinessLogin: false,
      hideBusiness: false,

      // Unified login/signup fields
      useEmail: false,
      loginPhone: {
        number: "",
      },
      loginPhoneInvalid: false,
      loginPhoneCountryCode: "+91",
      otpCode: "",
      useOtp: true,
      setPasswordMode: false,
      setPassword: "",
      confirmPassword: "",
      otpSent: false,
      showSetPasswordOtp: false,
      isResetPasswordMode: false,
      isNewUserPasswordSetup: false,
      userExists: null,
      hasPassword: null,
      sendOtpError: "",

      // Registration/Login Shared Fields
      email: "",
      username: "",
      password: "",
      rePassword: "",
      reConfirmpassword: "",
      showPass: false,
      showPassword: false,
      showSetPassword: false,
      show: false,

      // Registration form object (used by existing mixin logic)
      regForm: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: "",
        confirmpassword: "",
        countryCode: "+91",
        termsCondition: false,
        referralCode: "",
      },

      // Focus States
      isFocused: false,

      sliderIndex: 0,
      sliderTimer: null,
      sliderImages: [
        require("@/assets/img/homepage/modal-left-1.png"),
        require("@/assets/img/homepage/modal-left-2.png"),
        require("@/assets/img/homepage/modal-left-3.png"),
        require("@/assets/img/homepage/modal-left-4.png"),
      ],

      otpDigits: {
        num1: null,
        num2: null,
        num3: null,
        num4: null,
        num5: null,
        num6: null,
      },

      // Flags and Status
      verifyotp: false,
      LoaderStatus: false,
      invalidCredential: false,
      invalidText: "",
      successText: "",
      registered: false,
      timerOut: false,
      remainingTime: 0,
      timer: null,
      emailExists: false,
      invalidPhone: false,
      match: false,
      validPassword: false,

      // Password Validation Strings
      passwordminlength: "",
      passwordupper: "",
      passwordlower: "",
      passwordspecial: "",
      passwordnumber: "",
      wrongReferral: false,
      candExists: false,
      showPopup: false,
      countryCode: "+91",
      retryAfter: 0,
      otpExceeded: false,
      dialCodeLength: 2,
      itis: [],
      registeredLogin: false,
    };
  },
  created() {
    this._onOpenLoginModal = (payload) => {
      if (payload) {
        if (typeof payload === "string") {
          this.incomingMode = payload;
        } else {
          this.incomingMode = payload.mode || "login";
          this.incomingUserType = payload.userType || null;
          this.redirectUrl = payload.redirectUrl || null;
          this.hideBusiness = payload.hideBusiness || false;
        }
      }
      this.isOpen = true;
    };
    this._onCloseLoginModal = () => {
      this.isOpen = false;
    };
    eventBus.$on("open-login-modal", this._onOpenLoginModal);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this._resizeHandler);
    eventBus.$off("open-login-modal", this._onOpenLoginModal);
    eventBus.$off("close-login-modal", this._onCloseLoginModal);
    this.stopSlider();
    document.body.classList.remove("login-modal-open");
  },

  mounted() {
    this.startSlider();
    this._resizeHandler = () => {
      this.windowWidth = window.innerWidth;
    };
    window.addEventListener("resize", this._resizeHandler);
    eventBus.$on("close-login-modal", this._onCloseLoginModal);
    if (this.userType === "candidate" && !this.useEmail) {
      this.$nextTick(() => {
        this.initializeTel();
      });
    }
  },
  computed: {
    ...mapGetters({
      userData: "userVUEX/getUserData",
      mobileToken: "userVUEX/getMobileToken",
      getResumeuuid: "userVUEX/getResumeuuid",
      getResumejobid: "userVUEX/getResumejobid",
    }),

    isMobile() {
      return this.windowWidth <= 1028;
    },
    loaderLabel() {
      return this.useOtp && !this.registeredLogin ? "Loading" : "Logging In";
    },

    formattedTime() {
      let seconds = this.remainingTime;
      if (seconds < 60) {
        return `${seconds} ${seconds === 1 ? "sec" : "secs"}`;
      }

      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;

      let result = `${mins} ${mins === 1 ? "min" : "mins"}`;

      if (secs > 0) {
        result += ` ${secs} ${secs === 1 ? "sec" : "secs"}`;
      }

      return result;
    },
    formatEmail() {
      let str = this.userData.email.split("@")[0];
      if (str.length <= 5) {
        str = str.substring(0, 1) + "****" + str.substring(str.length - 1);
      } else {
        str = str.substring(0, 2) + "****" + str.substring(str.length - 2);
      }
      let value = str + "@" + this.userData.email.split("@")[1];
      return value;
    },
    passwordValidation() {
      let val = [];
      if (this.passwordminlength) {
        val.push(this.passwordminlength);
      }
      if (this.passwordupper) {
        val.push(this.passwordupper);
      }
      if (this.passwordlower) {
        val.push(this.passwordlower);
      }
      if (this.passwordspecial) {
        val.push(this.passwordspecial);
      }
      if (this.passwordnumber) {
        val.push(this.passwordnumber);
      }
      return val.join(", ");
    },
    checkpassowrdInvalid() {
      return (
        this.passwordminlength ||
        this.passwordupper ||
        this.passwordlower ||
        this.passwordspecial ||
        this.passwordnumber
      );
    },
  },

  validations() {
    return {
      username: {
        required,
        email,
        maxLength: maxLength(64),
        alphaEmail: (value) => {
          if (value === null) return true;
          return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(value);
        },
      },
      email: {
        required: requiredIf(function () {
          return this.useEmail || this.userType !== "candidate";
        }),
        email,
        alphaEmail: (value) => {
          if (value === null || value === "") return true;
          return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(value);
        },
        maxLength: maxLength(64),
      },
      loginPhone: {
        number: {
          required: requiredIf(function () {
            return !this.useEmail && this.userType === "candidate";
          }),
        },
      },
      otpCode: {
        required,
        numeric,
        minLength: minLength(6),
      },
      password: {
        required,
        maxLength: maxLength(55),
      },
      confirmpassword: {
        required,
        maxLength: maxLength(55),
      },
      confirmPassword: {
        required,
        maxLength: maxLength(55),
      },
      setPassword: {
        required,
        maxLength: maxLength(55),
      },
      rePassword: {
        required,
        maxLength: maxLength(55),
      },
      reConfirmpassword: {
        required,
        maxLength: maxLength(55),
      },
      regForm: {
        email: {
          required,
          alphaEmail: (value) => {
            if (value === null) return true;
            return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(value);
          },
          email,
          maxLength: maxLength(64),
        },
        password: {
          required,
          maxLength: maxLength(55),
        },
        firstName: {
          required,
          maxLength: maxLength(38),
          alphaNumeric: helpers.regex(
            "alphaNumeric",
            /^(?![ .])[a-zA-Z\s.]+(?:\.[a-zA-Z\s.]+)?$/,
          ),
        },
        lastName: {
          required,
          maxLength: maxLength(38),
          alphaNumeric: helpers.regex(
            "alphaNumeric",
            /^(?![ .])[a-zA-Z]+(?:\.[a-zA-Z]+)?$/,
          ),
        },
        confirmpassword: {
          required,
          maxLength: maxLength(55),
        },
        phoneNumber: {
          required,
        },
        referralCode: {
          // alpha: helpers.regex("alpha", /^[6-9]\d{9}$/),
        },
      },
      otpDigits: {
        num1: { required },
        num2: { required },
        num3: { required },
        num4: { required },
        num5: { required },
        num6: { required },
      },
    };
  },

  //Adding Watchers for login and registration fields from LOginModal's LoginMixin
  watch: {
    show(val){
			if(!val) this.registeredLogin = false;
		},
    $route() {
      if (this.isOpen) {
        this.isOpen = false;
      }
    },
    isOpen(val) {
      if (val) {
        document.body.classList.add("login-modal-open");
        if (this.userType === "candidate" && !this.useEmail) {
          this.$nextTick(() => {
            this.initializeTel();
          });
        }
      } else {
        document.body.classList.remove("login-modal-open");
        eventBus.$emit("close-login-modal");
        this.destroyTel();
      }
    },
    userTypeProp(val) {
      this.userType = val;
    },
    userType(val) {
      this.clearData();
      if (val === "candidate") {
        this.$nextTick(() => {
          this.initializeTel();
        });
      } else {
        this.destroyTel();
      }
    },
    mode(val) {
      this.clearData();
      if (val === "forgot") this.clearTimerData();
    },
    useEmail(val) {
      if (!val && this.userType === "candidate") {
        this.$nextTick(() => {
          this.initializeTel();
        });
      } else if (val) {
        this.destroyTel();
      }
    },
    "loginPhone.number"(val) {
      if (!val || val.trim() === "") {
        this.loginPhoneInvalid = false;
        if (this.$v.loginPhone && this.$v.loginPhone.number) {
          this.$v.loginPhone.number.$reset();
        }
        return;
      }
      if (this.$v.loginPhone && this.$v.loginPhone.number) {
        this.$v.loginPhone.number.$touch();
      }
      const value = val.replace(/\s+/g, "");
      const cleanCountry = this.loginPhoneCountryCode
        ? this.loginPhoneCountryCode.toString().replace(/[\s+]/g, "")
        : "91";
      if (cleanCountry === "91") {
        const indianPhoneNumberRegex = /^[6-9]\d{9}$/;
        this.loginPhoneInvalid = !indianPhoneNumberRegex.test(value);
      }
    },
    loginPhoneCountryCode(newVal) {
      const cleanCountry = newVal
        ? newVal.toString().replace(/[\s+]/g, "")
        : "91";
      if (cleanCountry === "91") {
        const val = this.loginPhone.number || "";
        if (!val || val.trim() === "") {
          this.loginPhoneInvalid = false;
          return;
        }
        const cleanVal = val.replace(/\s+/g, "");
        this.loginPhoneInvalid = !/^[6-9]\d{9}$/.test(cleanVal);
      }
    },
    otpCode(newVal) {
      const digits = newVal.toString().replace(/\D/g, "").slice(0, 6).split("");
      this.otpDigits.num1 = digits[0] || "";
      this.otpDigits.num2 = digits[1] || "";
      this.otpDigits.num3 = digits[2] || "";
      this.otpDigits.num4 = digits[3] || "";
      this.otpDigits.num5 = digits[4] || "";
      this.otpDigits.num6 = digits[5] || "";
      if (this.$v.otpCode && newVal && newVal.trim() !== "") {
        this.$v.otpCode.$touch();
      }
    },
    setPassword(value) {
      if (this.$v.setPassword && value && value.trim() !== "") {
        this.$v.setPassword.$touch();
      }
      if (this.confirmPassword) {
        this.match = value !== this.confirmPassword;
      }
    },
    confirmPassword(value) {
      if (this.$v.confirmPassword && value && value.trim() !== "") {
        this.$v.confirmPassword.$touch();
      }
      if (!value || value.trim() === "") {
        this.match = false;
      } else if (this.setPassword) {
        this.match = value !== this.setPassword;
      }
    },
    username(newVal, oldVal) {
      if (newVal) {
        this.username = newVal.replace(/\s/, "").toLowerCase();
      }
      if (newVal !== oldVal) {
        this.invalidText = "";
        this.invalidCredential = false;
      }
    },
    password(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.invalidText = "";
        this.invalidCredential = false;
      }
    },
    "otpDigits.num1"(val) {
      if (val && val.length != 1) {
        this.otpDigits.num2 = val[1];
        this.otpDigits.num3 = val[2];
        this.otpDigits.num4 = val[3];
        this.otpDigits.num5 = val[4];
        this.otpDigits.num6 = val[5];
        this.otpDigits.num1 = val[0];
        const prevInput =
          val.length == 2
            ? this.$refs["secondInput"]
            : val.length == 3
            ? this.$refs["thirdInput"]
            : val.length == 4
            ? this.$refs["fourthInput"]
            : val.length == 5
            ? this.$refs["fifthInput"]
            : this.$refs["sixthInput"];
        if (prevInput) {
          prevInput.focus();
        }
      }
    },
    "regForm.phoneNumber"(val) {
      const value = val.replace(/\s+/g, "");
      if (
        this.$v.regForm.phoneNumber.$dirty &&
        this.regForm.countryCode == "+91"
      ) {
        const indianPhoneNumberRegex = /^[6-9]\d{9}$/;
        if (indianPhoneNumberRegex.test(value)) {
          this.invalidPhone = false;
        } else {
          this.invalidPhone = true;
        }
      }
    },
    "regForm.password"(value) {
      if (this.regForm.confirmpassword) {
        if (value == this.regForm.confirmpassword) {
          this.match = false;
        } else {
          this.match = true;
        }
      }
    },
    "regForm.confirmpassword"(value) {
      if (this.regForm.password) {
        if (value == this.regForm.password) {
          this.match = false;
        } else {
          this.match = true;
        }
      }
    },
    rePassword(value) {
      if (this.reConfirmpassword) {
        if (value == this.reConfirmpassword) {
          this.match = false;
        } else {
          this.match = true;
        }
      }
    },
    reConfirmpassword(value) {
      if (this.rePassword) {
        if (value == this.rePassword) {
          this.match = false;
        } else {
          this.match = true;
        }
      }
    },
    "regForm.email"(value) {
      if (value) {
        this.regForm.email = value.replace(/\s/, "").toLowerCase();
        if (!this.$v.regForm.email.$error && !this.$v.regForm.email.$invalid)
          this.debouncedCheckEmail();
        else this.emailExists = false;
      } else this.emailExists = false;
    },
    "regForm.referralCode"(value) {
      if (value != "" || value != null) {
        this.wrongReferral = false;
      }
    },
    otpCode(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.invalidText = "";
        this.invalidCredential = false;
      }
    },
  },

  methods: {
    ...mapMutations({
      setToken: "userVUEX/SET_TOKEN",
      setRefreshToken: "userVUEX/SET_REFRESH_TOKEN",
    }),
    ...mapActions({
      userLogin: "userVUEX/Login",
      saveAccess: "userVUEX/saveAccess",
    }),
    clearTimerData() {
      this.remainingTime = 0;
      this.retryAfter = 0;
      this.otpExceeded = false;
    },
    formatDuration(seconds) {
      if (seconds < 60) {
        return `${seconds} ${seconds === 1 ? "sec" : "secs"}`;
      }

      const mins = Math.floor(seconds / 60);
      return `${mins} ${mins === 1 ? "min" : "mins"}`;
    },
    goToHire3xHome() {
      window.location.href = `${appConfig.websiteBase}`;
    },
    closeLoginModal() {
      this.isOpen = false;
      this.$store.commit("userVUEX/setDownloadReport", false);
    },

    async validateUser() {
      await this.login();
    },

    async login() {
      if (this.$refs.candmail && typeof this.$refs.candmail.blur === "function")
        this.$refs.candmail.blur();
      if (this.$refs.candpass && typeof this.$refs.candpass.blur === "function")
        this.$refs.candpass.blur();
      if (
        this.$refs.phoneInput &&
        typeof this.$refs.phoneInput.blur === "function"
      )
        this.$refs.phoneInput.blur();
      this.invalidCredential = false;
      clearAllCookiesExceptGuest();
      this.clearStore();
      localStorage.clear();
      let flag = this.userType;

      if (this.useEmail || flag !== "candidate") {
        const isOtpFlow = this.useOtp && this.otpSent;
        const capturedOtpCode = this.otpCode;
        if (this.$v.email.$invalid) {
          this.$v.email.$touch();
        } else if (
          !isOtpFlow &&
          this.hasPassword !== false &&
          this.$v.password.$invalid
        ) {
          this.$v.password.$touch();
        }
        if (
          !this.$v.email.$invalid &&
          (isOtpFlow ||
            this.hasPassword === false ||
            !this.$v.password.$invalid)
        ) {
          this.show = true;
          this.LoaderStatus = true;
          const creds =
            isOtpFlow || this.hasPassword === false
              ? { username: this.email, otp: capturedOtpCode }
              : { username: this.email, password: this.password };
          await this.loginToProjects(flag, creds);
        }
      } else {
        const isOtpFlow = this.useOtp && this.otpSent;
        const capturedOtpCode = this.otpCode;
        if (this.$v.loginPhone.number.$invalid) {
          this.$v.loginPhone.number.$touch();
          this.loginPhoneInvalid = true;
        } else if (
          !isOtpFlow &&
          this.hasPassword !== false &&
          this.$v.password.$invalid
        ) {
          this.$v.password.$touch();
        }
        if (this.loginPhoneInvalid) return;
        if (
          !this.$v.loginPhone.number.$invalid &&
          !this.loginPhoneInvalid &&
          (isOtpFlow ||
            this.hasPassword === false ||
            !this.$v.password.$invalid)
        ) {
          const phoneNumber = this.loginPhone.number.replace(/\D/g, "");
          this.show = true;
          this.LoaderStatus = true;
          const creds =
            isOtpFlow || this.hasPassword === false
              ? { username: phoneNumber, otp: capturedOtpCode }
              : { username: phoneNumber, password: this.password };
          await this.loginToProjects(flag, creds);
        }
      }
    },

    async loginToProjects(flag, creds) {
      this.show = true;
      this.LoaderStatus = true;
      try {
        let usernameVal = creds
          ? creds.username || creds.email
          : this.username.trim();

        let userData = {
          grant_type: "password",
          client_id: "vue-test-app",
          username: usernameVal,
        };
        if (creds && creds.otp !== undefined) {
          userData.otp = creds.otp;
        } else {
          userData.password = creds ? creds.password : this.password.trim();
        }

        let userDetails = {
          keycloak: qs.stringify(userData),
          username: usernameVal,
          callSetCandAccess: true,
        };

        const res = await this.userLogin(userDetails);
        const isMobileLogin = creds && /^[0-9]+$/.test(creds.username);
        await this.getProjectsData(flag, false, undefined, isMobileLogin);
        this.show = false;
        this.LoaderStatus = false;
      } catch (error) {
        this.show = false;
        this.LoaderStatus = false;
        console.error(error);
        if (error.response && error.response.status == 401) {
          const isOtpLogin = creds && creds.otp !== undefined;
          const attemptsLeft =
            error.response.data && error.response.data.attempts_left;
          const attemptsMsg =
            attemptsLeft !== undefined
              ? ` ${attemptsLeft} ${
                  attemptsLeft === 1 ? "attempt" : "attempts"
                } left.`
              : ".";
          this.setNoAccess(
            isOtpLogin
              ? `Wrong OTP.${attemptsMsg}`
              : `Invalid credentials.${attemptsMsg}`,
            true,
          );
        } else if (error.response && error.response.status == 429) {
          this.setNoAccess(
            `Too many failed login attempts. Try again in ${this.formatDuration(
              error.response.data.retry_after,
            )}.`,
            true,
          );
        } else if (error.response && error.response.status == 400) {
          this.setNoAccess(
            error.response.data.error_description || "Login failed.",
            true,
          );
        } else {
          this.setNoAccess("Login failed! Please try again.");
        }
      }
    },

    async getProjectsData(
      flag,
      login,
      type,
      fallbackOnUserAccessFailure = false,
    ) {
      let loginData = {};
      try {
        let response;
        try {
          response = await userAccess();
        } catch (userAccessError) {
          // If user-access call fails and we're in a fallback-allowed flow
          // (e.g. mobile login/registration), proceed with synthetic candidate access.
          if (fallbackOnUserAccessFailure) {
            console.warn(
              "user-access call failed, proceeding with fallback:",
              userAccessError,
            );
            loginData = { showPreference: true, type: flag };
            const data = {
              details: [{ project: "candidate", isActive: true }],
              flag,
              loginData,
              redirectUrl: this.redirectUrl,
            };
            this.saveAccessRedirect(data);
            return;
          }
          throw userAccessError;
        }
        let projects = response.data.details.filter((obj) => {
          let val = obj.userPermissions
            ? obj.userPermissions.isActive
            : obj.isActive;
          if (val) return obj;
        });
        if (projects.length === 0) {
          this.setNoAccess("You don't have access.");
        } else if (
          projects.length == 1 &&
          projects[0].project == "candidate" &&
          flag != "candidate"
        ) {
          this.setNoAccess("You don't have access.");
        } else {
          loginData = {
            showPreference: true,
            type: flag,
          };
          if (type && type == "google") {
            loginData.logged_in = "google";
          }
          let data = {
            details: projects,
            flag,
            loginData,
            redirectUrl: this.redirectUrl,
          };
          if (flag == "candidate" && !this.checkAccess(data, flag)) {
            this.setNoAccess("You don't have access!");
          } else if (this.checkAccess(data, flag)) {
            // await this.setUserInfo();
            this.saveAccessRedirect(data);
          } else {
            data.flag = "admin";
            // await this.setUserInfo();
            this.saveAccessRedirect(data);
          }
        }
      } catch (error) {
        this.LoaderStatus = false;
        console.error(error);
        if (this.mode === "otp") {
          this.setFailurePopup("Login failed", true);
          clearAllCookiesExceptGuest();
        } else {
          clearAllCookiesExceptGuest();
          this.setNoAccess("Login failed! Please try again.");
        }
      }
    },

    saveAccessRedirect(data) {
      // eventBus.$emit("spinner-start");
      const { details, flag, loginData, redirectUrl } = data;

      // Build cookie expiry

      // Core projects to check against
      const coreProjects = [
        "recruitment",
        "assessment",
        "candidate",
        "training",
        "collegeDashboard",
      ];

      // Set 'no-access' cookie for any core project NOT present in the details array
      coreProjects.forEach((projName) => {
        const hasProject = details.some((p) => p.project === projName);
        if (!hasProject) {
          document.cookie = `${projName}=no-access;${COOKIE_OPTIONS_SUFFIX}`;
        }
      });

      // Save each active project as a cookie
      details.forEach((project) => {
        document.cookie = `${project.project}=${JSON.stringify(
          project,
        )};${COOKIE_OPTIONS_SUFFIX}`;
      });
      console.log("Setting loginData cookie with:", loginData);
      // Save loginData cookie
      let loginDataVal = { ...loginData, clearStore: true };
      document.cookie = `loginData=${JSON.stringify(
        loginDataVal,
      )};${COOKIE_OPTIONS_SUFFIX}`;
      this.$store.commit("userVUEX/setCandAccess", true);
      this.closeAndProceed(redirectUrl);
    },
    async closeAndProceed(redirectUrl) {
      if (redirectUrl) {
        if (
          redirectUrl.includes(appConfig.trainingBase) ||
          redirectUrl.startsWith("/")
        ) {
          const path = redirectUrl.replace(appConfig.trainingBase, "");
          this.LoaderStatus = false;
          this.closeLoginModal();
          eventBus.$emit("spinner-start");
          this.$router.push(path).catch(() => {});
          eventBus.$emit("login-success", this.username.trim());
          return;
        } else {
          this.closeLoginModal();
          window.location.href = redirectUrl;
          return;
        }
      }
      if (this.getResumeuuid) {
        const newUser = this.$store.getters["userVUEX/getNewUseruuid"];
        if (newUser) {
          const uuid = this.getResumeuuid;
          this.$store.commit("userVUEX/setNewUseruuid", null);
          this.$store.commit("userVUEX/setresumeClinicuid", null);
          this.$store.commit("userVUEX/setresumeJobid", null);
          let url = `${appConfig.candidateBase}/dashboard/?from=candidate&fromWebsite=true&uuid=${uuid}`;

          if (this.$store.getters["userVUEX/getDownloadReport"]) {
            this.$store.commit("userVUEX/setDownloadReport", false);
            url += `&downloadReport=true`;
          } else {
            url += `&openResumeClinic=true`;
          }

          this.closeLoginModal();
          window.location.replace(url);
        } else if (this.getResumejobid && this.getResumeuuid) {
          const url = `${appConfig.candidateBase}/job/search/?from=candidate`;
          const jobid = this.getResumejobid;
          const uuid = this.getResumeuuid;
          this.$store.commit("userVUEX/setresumeClinicuid", null);
          this.$store.commit("userVUEX/setresumeJobid", null);
          this.closeLoginModal();
          window.location.replace(
            `${url}&jobID=${jobid}&uuid=${uuid}&fromProject=${this.$route.name}`,
          );
          return;
        } else if (this.getResumeuuid) {
          let url = `${appConfig.candidateBase}/dashboard?from=candidate`;
          const uuid = this.getResumeuuid;
          this.$store.commit("userVUEX/setresumeClinicuid", null);
          this.$store.commit("userVUEX/setresumeJobid", null);

          if (this.$store.getters["userVUEX/getDownloadReport"]) {
            this.$store.commit("userVUEX/setDownloadReport", false);
            url += `&downloadReport=true`;
          } else {
            url += `&openResumeClinic=true`;
          }

          this.closeLoginModal();
          window.location.replace(`${url}&uuid=${uuid}`);
          return;
        }
        return;
      } else {
        try {
          // Step 1: Check onboarding status
          const onboardRes = await getCandidateOnboard();
          const onboardData = onboardRes?.data?.data;
          console.log(
            "[Onboarding][loginMixin] getCandidateOnboard response:",
            onboardData,
          );
          if(onboardRes.status === 404 || (onboardRes.status == 200 && onboardData?.onboardingCompleted == false)){
            const returnUrl = encodeURIComponent(window.location.href);
              window.location.href = `${appConfig.candidateBase}/homepage?from=candidate&fromTraining=1&returnUrl=${returnUrl}`;
          }
          else if (
            onboardData?.onboardingCompleted === true ||
            onboardData?.onboardingCompleted === null
          ) {
            // Onboarding done — skip checkCandidateSignin, proceed normally
            this.LoaderStatus = false;
            this.closeLoginModal();
            eventBus.$emit("spinner-start");
            eventBus.$emit("login-success", this.username.trim());
            return;
          }
        } catch (error) {
           try {
          const userID = getProcessedToken();
          if (userID) {
            const checkRes = await checkCandidateSignin({
              check_completion: "true",
              userID,
            });
            const isCandidate = checkRes?.data?.data?.isCandidate;
            if (isCandidate === false || isCandidate === "false") {
              const returnUrl = encodeURIComponent(window.location.href);
              console.log(
                "[App] isCandidate=false, redirecting to candidate URL",
              );
              window.location.href = `${appConfig.candidateBase}/homepage?from=candidate&fromTraining=1&returnUrl=${returnUrl}`;
            }
          }
        } catch (signinError) {
          console.error(
            "checkCandidateSignin failed, proceeding normally:",
            signinError,
          );
          // API failed - do not block the user, proceed normally
          this.LoaderStatus = false;
          this.closeLoginModal();
          eventBus.$emit("spinner-start");
          eventBus.$emit("login-success", this.username.trim());
        }
      }
    }
    },

    // async setUserInfo() {
    //   const userInfoRes = await canRegister();

    //   if (userInfoRes.status === 200) {
    //     this.$store.commit("userVUEX/setUserInfo", userInfoRes.data.data);
    //   }
    // },

    createjwtToken(token) {
      const secret = token;
      const data = {
        exp: Math.floor(Date.now() / 1000) + 60 * 60,
        sub: token,
      };
      const jwt = sign(data, secret, { algorithm: "RS256" });
      return jwt;
    },
    async ssoLogin(tokenval, authtoken, type) {
      try {
        this.LoaderStatus = true;
        let payload = {
          token: authtoken,
          authType: type,
          origin: window.location.origin
        };
        const resp = await googleLinkedInLogin(payload, tokenval);
        if (resp.status == 200) {
          this.$store.commit("userVUEX/SET_TOKEN", resp.data.data.access_token);
          this.$store.commit(
            "userVUEX/SET_REFRESH_TOKEN",
            resp.data.data.refresh_token,
          );
          setToken(resp.data.data.access_token);
          setRefreshToken(resp.data.data.refresh_token);
          this.getProjectsData("candidate", false, "google");
        } else {
          this.LoaderStatus = false;
          this.setNoAccess("Invalid credentials.");
        }
      } catch (error) {
        this.LoaderStatus = false;
        this.setNoAccess("Login failed.");
      }
    },

    async googleLogin() {
      googleAuthCodeLogin()
        .then((response) => {
          const code = response.code;
          this.show = true
          const jwt = this.createjwtToken(code);
          this.ssoLogin(jwt, code, "google");
        })
        .catch((error) => {
          console.error("Web Google Sign-In error:", error);
          this.setNoAccess("Google Sign-In failed. Please try again.");
        });
    },

    // Methods from LoginMixin of LoginModal file.
    // ─── Helpers ──────────────────────────────────────────────────────────────
    startSlider() {
      this.sliderTimer = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    stopSlider() {
      if (this.sliderTimer) {
        clearInterval(this.sliderTimer);
      }
    },
    nextSlide() {
      this.sliderIndex = (this.sliderIndex + 1) % this.sliderImages.length;
    },
    setSlide(index) {
      this.sliderIndex = index;
      this.stopSlider();
      this.startSlider();
    },
    clearAndReset(clearRedirect = true) {
      if (!clearRedirect) {
        if (this.incomingMode) {
          this.mode = this.incomingMode;
          this.incomingMode = null;
        } else {
          this.mode = "login";
        }
        this.userType = this.userTypeProp;
      }
      this.LoaderStatus = false;
      // this.$store.commit("userVUEX/setresumeJobid", null);
      // this.$store.commit("userVUEX/setresumeClinicuid", null);
      this.clearData();
      if (clearRedirect) {
        this.redirectUrl = null;
      }
    },
    terms() {
      const link = document.createElement("a");
      link.href =
        "https://cvstaticfiles.s3.ap-south-1.amazonaws.com/candidate/documents/Terms+and+Conditions+Hire3x.docx";
      link.download = "Terms_and_Conditions_Hire3x.docx"; // Suggested filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    goToPrivacyPolicy() {
      window.open(
        "https://cvstaticfiles.s3.ap-south-1.amazonaws.com/candidate/documents/General+Privacy+Policy+for+hire3x.pdf",
      );
    },
    convertToUppercase() {
      this.regForm.referralCode = this.regForm.referralCode.toUpperCase();
    },
    handleFocus() {
      this.isFocused = true;
    },
    handleBlur() {
      this.isFocused = false;
    },
    checkAccess(data, flag) {
      let val = data.details.filter((obj) => {
        if (obj.project == flag) {
          let active = obj.userPermissions
            ? obj.userPermissions.isActive
            : obj.isActive;
          if (active) return obj;
        }
      });
      return val.length !== 0;
    },

    setFailurePopup(message, login) {
      this.LoaderStatus = false;
      this.showPopup = true;
      this.invalidText = message;
      setTimeout(() => {
        this.showPopup = false;
        this.invalidText = "";
        this.candExists = false;
        if (login) {
          this.clearData();
          this.mode = "login";
          this.userType = "candidate";
        }
      }, 5000);
    },
    setNoAccess(message, notClear) {
      this.LoaderStatus = false;
      this.invalidCredential = true;
      this.invalidText = message;
      if (!notClear) {
        setTimeout(() => {
          this.invalidText = "";
          this.invalidCredential = false;
        }, 5000);
      }
    },
    clearStore() {
      this.$store.commit("userVUEX/SET_TOKEN", "");
      this.$store.commit("userVUEX/SET_REFRESH_TOKEN", "");
      // this.$store.commit("userVUEX/setPreference", {});
    },
    clearData() {
      this.invalidCredential = false;
      this.invalidText = "";
      this.email = "";
      this.invalidPhone = false;
      this.emailExists = false;
      this.countryCode = "+91";
      this.wrongReferral = false;
      this.registered = false;
      this.successText = "";
      this.username = "";
      this.password = "";
      this.showPassword = false;
      this.showPass = false;
      this.showSetPassword = false;
      this.passwordminlength = "";
      this.passwordupper = "";
      this.passwordlower = "";
      this.passwordspecial = "";
      this.passwordnumber = "";
      this.validPassword = false;
      this.match = false;
      this.regForm = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: "",
        confirmpassword: "",
        countryCode: "+91",
        termsCondition: false,
        referralCode: "",
      };
      this.rePassword = "";
      this.reConfirmpassword = "";
      this.useEmail = false;
      this.otpSent = false;
      if (this.loginPhone) {
        this.loginPhone.number = "";
      }
      this.loginPhoneCountryCode = "+91";
      this.loginPhoneInvalid = false;
      this.otpCode = "";
      this.useOtp = true;
      this.setPasswordMode = false;
      this.setPassword = "";
      this.confirmPassword = "";
      this.showSetPasswordOtp = false;
      this.isResetPasswordMode = false;
      this.isNewUserPasswordSetup = false;
      this.userExists = null;
      this.hasPassword = null;
      this.sendOtpError = "";
      this.clearOtp();
      this.$v.$reset();
    },

    // ─── OTP Timer ────────────────────────────────────────────────────────────

    pad(val) {
      return val < 10 ? "0" + val : val;
    },
    startTimer() {
      clearTimeout(this.timer);
      this.remainingTime = this.retryAfter;
      this.timer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
        } else {
          clearInterval(this.timer);
          this.timerOut = false;
          this.otpExceeded = false;
          this.remainingTime = this.retryAfter;
        }
      }, 1000);
    },
    clearTimer() {
      clearInterval(this.timer);
    },

    // ─── OTP Input ────────────────────────────────────────────────────────────

    restrictToOneDigit(event) {
      if (["e", "E", "+", "-", "."].includes(event.key)) {
        event.preventDefault();
        return;
      }
      const currentValue = event.target.value;
      if (currentValue && currentValue.length >= 1) {
        event.preventDefault();
      }
    },
    moveToNextField(event, nextInputRef, prevInputRef) {
      if (event.target.value && event.target.value.length >= 1) {
        const nextInput = this.$refs[nextInputRef];
        if (this.handleBackspace(event)) {
          if (nextInput && event.keyCode !== 9) nextInput.focus();
        } else {
          const prevInput = this.$refs[prevInputRef];
          if (prevInput) {
            setTimeout(() => {
              prevInput.focus();
            }, 0);
          }
        }
      }
    },
    handleBackspace(event) {
      return !(event.keyCode === 8 || event.keyCode === 46);
    },
    clearOtp() {
      this.otpDigits.num1 = null;
      this.otpDigits.num2 = null;
      this.otpDigits.num3 = null;
      this.otpDigits.num4 = null;
      this.otpDigits.num5 = null;
      this.otpDigits.num6 = null;
      this.otpCode = "";
      const nextInput = this.$refs["firstInput"];
      if (nextInput) nextInput.focus();
      this.$v.otpDigits.$reset();
      if (this.$v.otpCode) this.$v.otpCode.$reset();
    },

    // ─── Password validation ──────────────────────────────────────────────────

    validatePassword(PasswordField = "password") {
      let pwd = "";
      if (PasswordField === "rePassword") {
        pwd = this.rePassword;
      } else if (PasswordField === "setPassword") {
        pwd = this.setPassword;
      } else {
        pwd = this.regForm.password;
      }
      this.passwordminlength = pwd.length < 6 ? "Min 6 char required" : "";
      this.passwordupper = !/^(.*[A-Z]){1,}.*$/.test(pwd) ? "1 Upper Case" : "";
      this.passwordlower = !/^(.*[a-z]){3}.*$/.test(pwd) ? "3 Lower Case" : "";
      this.passwordspecial =
        !/^(.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]){1,}.*$/.test(pwd)
          ? "1 special character"
          : "";
      this.passwordnumber = !/^(.*\d){1,}.*$/.test(pwd) ? "1 number" : "";
      this.validPassword =
        this.passwordminlength ||
        this.passwordupper ||
        this.passwordlower ||
        this.passwordspecial ||
        this.passwordnumber
          ? true
          : false;
    },

    otpNumbersOnly(evt) {
      const charCode = evt.key;
      if (charCode < "0" || charCode > "9") {
        evt.preventDefault();
      }
    },

    toggleLoginMode(isEmail) {
      this.useEmail = isEmail;
      this.useOtp = true;
      this.password = "";
      this.otpCode = "";
      this.otpSent = false;
      this.email = "";
      if (this.loginPhone) {
        this.loginPhone.number = "";
      }
      this.loginPhoneInvalid = false;
      this.sendOtpError = "";
      this.invalidCredential = false;
      this.invalidText = "";
      this.$v.$reset();
    },

    handleEdit() {
      this.setPasswordMode = false;
      this.showSetPasswordOtp = false;
      this.isResetPasswordMode = false;
      this.isNewUserPasswordSetup = false;
      this.otpSent = false;
      this.otpCode = "";
      this.setPassword = "";
      this.confirmPassword = "";
      this.sendOtpError = "";
      this.userExists = null;
      this.hasPassword = null;
      this.useOtp = true;
      this.password = "";
      this.invalidCredential = false;
      this.invalidText = "";
      this.clearOtp();
      this.clearTimer();
      this.timerOut = false;
      this.otpExceeded = false;
      this.$v.$reset();
    },

    handleIdentifierEdit() {
      this.otpSent = false;
      this.otpCode = "";
      this.password = "";
      this.setPassword = "";
      this.confirmPassword = "";
      this.sendOtpError = "";
      this.setPasswordMode = false;
      this.showSetPasswordOtp = false;
      this.isResetPasswordMode = false;
      this.isNewUserPasswordSetup = false;
      this.useOtp = true;
      this.invalidCredential = false;
      this.userExists = null;
      this.hasPassword = null;
      this.clearTimer();
      this.timerOut = false;
      this.$v.$reset();
      if (!this.useEmail && this.userType === "candidate") {
        this.$nextTick(() => {
          this.initializeTel();
        });
      }
    },

    usePassword() {
      this.useOtp = false;
      this.otpCode = "";
      this.clearOtp();
      if (this.$v.password) this.$v.password.$reset();
      this.invalidCredential = false;
      this.invalidText = "";
    },

    usePasswordOrSetup() {
      if (this.hasPassword === false) {
        // User exists but has no password — send reset-password OTP then show Set Password
        this.isNewUserPasswordSetup = true;
        this.openPasswordSetup(true);
      } else {
        this.usePassword();
      }
    },

    useOtpLogin() {
      this.useOtp = true;
      this.password = "";
      if (this.$v.password) this.$v.password.$reset();
      this.invalidCredential = false;
      this.invalidText = "";
      // Restart the timer if there's a live countdown from the already-sent login-account OTP
      if (this.retryAfter > 0 && this.remainingTime > 0) {
        this.timerOut = true;
        this.startTimer();
      }
    },

    openPasswordSetup(isReset = false) {
      this.setPasswordMode = true;
      this.isResetPasswordMode = isReset;
      if (!isReset) this.isNewUserPasswordSetup = false;
      this.showSetPasswordOtp = true;
      this.password = "";
      this.otpCode = "";
      this.setPassword = "";
      this.confirmPassword = "";
      this.match = false;
      this.passwordminlength = "";
      this.passwordupper = "";
      this.passwordlower = "";
      this.passwordspecial = "";
      this.passwordnumber = "";
      this.validPassword = false;
      this.clearOtp();
      if (this.$v.password) this.$v.password.$reset();
      if (this.$v.setPassword) this.$v.setPassword.$reset();
      if (this.$v.confirmPassword) this.$v.confirmPassword.$reset();
      this.invalidCredential = false;
      this.invalidText = "";
      if (isReset) {
        this._savedTimerOut = this.timerOut;
        this._savedRetryAfter = this.retryAfter;
        this._savedRemainingTime = this.remainingTime;
        this.$nextTick(() => {
          this.forgotPassword();
        });
      }
    },

    goToDemo() {
      window.location.href = `${appConfig.websiteBase}requestdemo`;
    },
    preventPaste(event) {
      event.preventDefault();
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z .]+$/.test(char)) return true; // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    isLetterandSpace(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z]+$/.test(char)) return true;
      else e.preventDefault();
    },
    numbersOnly(evt) {
      if (evt.target.nodeName === "INPUT") {
        const charCode = evt.key;
        if ((charCode < "0" || charCode > "9") && charCode !== ".") {
          evt.preventDefault();
        } else {
          if (
            this.regForm.countryCode == "+91" &&
            this.regForm.phoneNumber?.length >= 11
          ) {
            evt.preventDefault();
          }
        }
      }
    },

    async registerCandidate() {
      this.verifyotp = true;
      if (this.$refs.setPassField) this.$refs.setPassField.blur();
      if (this.$refs.confirmPassField) this.$refs.confirmPassField.blur();
      if (this.$refs.candmail) this.$refs.candmail.blur();
      if (this.$refs.phoneInput) this.$refs.phoneInput.blur();
      if (this.$refs.candotp) this.$refs.candotp.blur();

      if (this.useEmail && this.$v.email.$invalid) {
        this.$v.email.$touch();
      } else if (!this.useEmail && this.$v.loginPhone.number.$invalid) {
        this.$v.loginPhone.number.$touch();
      } else if (this.$v.otpCode.$invalid) {
        this.$v.otpCode.$touch();
      } else if (this.setPasswordMode && this.$v.setPassword.$invalid) {
        this.$v.setPassword.$touch();
      } else if (
        this.setPasswordMode &&
        (this.$v.confirmPassword.$invalid || this.match)
      ) {
        this.$v.confirmPassword.$touch();
      }

      this.show = true;
      this.verifyotp = false;
      const otpVal = this.otpCode;
      let payload = { ...this.userData };
      if (this.setPassword) payload.password = this.setPassword.trim();
      payload.otp = Number(otpVal);
      if (this.getResumeuuid) payload.uuid = this.getResumeuuid;

      try {
        const response = await registerCand(payload);
        if (response.status == 200) {
          if (this.getResumeuuid) {
            this.$store.commit("userVUEX/setNewUseruuid", true);
          }
          clearInterval(this.timer);
          this.show = false;
          this.registered = true;
          this.successText = "Registered successfully";

          setTimeout(async () => {
            this.registered = false;
            this.successText = "";
            this.registeredLogin = true;
            this.show = true;
            try {
              let username = "";
              if (this.useEmail) {
                username = (this.userData.email || this.email || "").trim();
              } else {
                username = (
                  this.userData.phoneNumber ||
                  this.loginPhone.number ||
                  ""
                ).replace(/\D/g, "");
              }
              const registrationPassword =
                this.setPassword ||
                (this.userData && this.userData.password) ||
                "";
              const regCreds = registrationPassword
                ? { username, password: registrationPassword }
                : { username, otp: this.otpCode };
              this.closeLoginModal();
              await this.loginToProjects("candidate", regCreds);
            } catch (err) {
              console.error("Auto-login failed:", err);
              this.setFailurePopup(
                "Login failed after registration. Please log in manually.",
              );
            } finally {
              this.clearData();
              this.clearOtp();
              this.$store.commit("userVUEX/setUserData", {});
            }
          }, 2000);
        } else if (response.status == 401 || response.status == 400) {
					this.show = false;
					this.setNoAccess("Wrong OTP");
				} else {
          this.show = false;
          this.setFailurePopup("Registration failed. Please try again.");
        }
      } catch (error) {
        this.show = false;
        const status = error.response && error.response.status;
				const msg =
				error.response && error.response.data && error.response.data.data
					? error.response.data.data.Detail
					: null;
				if (status == 400 || status == 401) {
				this.setNoAccess(msg || "Wrong OTP");
				} else {
				this.setFailurePopup(msg || "Registration failed. Please try again.");
				}
      }
    },

    async register(resend) {
      if (!resend) {
        clearAllCookiesExceptGuest();
        this.clearStore();
        localStorage.clear();
      }
      if (resend) {
        this.clearOtp();
      }
      if (!resend) {
        if (this.$refs.pass && typeof this.$refs.pass.blur === "function")
          this.$refs.pass.blur();
        if (
          this.$refs.phoneInput &&
          typeof this.$refs.phoneInput.blur === "function"
        )
          this.$refs.phoneInput.blur();

        if (this.useEmail && this.$v.email.$invalid) {
          this.$v.email.$touch();
        } else if (
          !this.useEmail &&
          (this.$v.loginPhone.number.$invalid || this.loginPhoneInvalid)
        ) {
          this.$v.loginPhone.number.$touch();
        } else if (this.setPasswordMode && this.$v.setPassword.$invalid) {
          this.$v.setPassword.$touch();
        } else if (
          this.setPasswordMode &&
          (this.$v.confirmPassword.$invalid || this.match)
        ) {
          this.$v.confirmPassword.$touch();
        }
      }
      const isIdentifierValid = this.useEmail
        ? !this.$v.email.$invalid
        : !this.$v.loginPhone.number.$invalid && !this.loginPhoneInvalid;
      if (
        (!resend &&
          isIdentifierValid &&
          !this.match &&
          !this.validPassword &&
          !this.loginPhoneInvalid) ||
        resend
      ) {
        this.show = true;
        this.LoaderStatus = true;
        if (!resend) {
          let userdata = {};
          if (this.useEmail) {
            if (this.email) userdata.email = this.email.trim();
          } else {
            userdata.countryCode = this.loginPhoneCountryCode
              ? this.loginPhoneCountryCode.trim()
              : "+91";
            userdata.phoneNumber = (this.loginPhone.number || "").replace(
              /\D/g,
              "",
            );
          }
          if (this.regForm.firstName)
            userdata.firstName = this.regForm.firstName.trim();
          if (this.regForm.lastName)
            userdata.lastName = this.regForm.lastName.trim();
          if (this.regForm.referralCode)
            userdata.code = this.regForm.referralCode.trim();
          if (this.password) userdata.password = this.password.trim();
          if (this.confirmPassword)
            userdata.confirmPassword = this.confirmPassword.trim();
          this.$store.commit("userVUEX/setUserData", userdata);
        }
        let otpPayload = {};
        if (this.useEmail) {
          otpPayload = {
            email: !resend ? this.email.trim() : this.userData.email,
          };
        } else {
          if (!resend) {
            const dialCode = this.loginPhoneCountryCode
              ? this.loginPhoneCountryCode.startsWith("+")
                ? this.loginPhoneCountryCode
                : "+" + this.loginPhoneCountryCode
              : "+91";
            otpPayload = {
              countryCode: dialCode,
              phoneNumber: (this.loginPhone.number || "").replace(/\D/g, ""),
            };
          } else {
            otpPayload = {
              countryCode: this.userData.countryCode,
              phoneNumber: this.userData.phoneNumber,
            };
          }
        }
        try {
          if (!resend) {
            const checkPayload = this.useEmail
              ? { email: this.email.trim() }
              : {
                  countryCode: this.loginPhoneCountryCode
                    ? this.loginPhoneCountryCode.startsWith("+")
                      ? this.loginPhoneCountryCode
                      : "+" + this.loginPhoneCountryCode
                    : "+91",
                  phoneNumber: (this.loginPhone.number || "").replace(
                    /\D/g,
                    "",
                  ),
                };
            const checkRes = await checkAndSendOTP(checkPayload);
            const checkData = checkRes.data?.data || checkRes.data;
            this.userExists = checkData.exists;
            this.hasPassword = checkData.hasPassword;
          }
          otpPayload.type =
            this.userExists === false ? "register-account" : "login-account";
          const otpRes = await sendOtp(otpPayload);
          if (otpRes.status == 200) {
            const resData = otpRes.data?.data || otpRes.data;
            const rawRetryAfter =
              resData.retryAfter ?? resData.cooldownSeconds ?? 0;
            this.retryAfter = rawRetryAfter >= 60 ? rawRetryAfter : 60;
            this.sendOtpError = "";
            this.show = false;
            this.LoaderStatus = false;
            if (this.retryAfter) {
              this.timerOut = true;
              this.startTimer();
            }
            this.otpSent = true;
            if (!resend && this.userType !== "candidate") this.mode = "otp";
          } else if (otpRes.status == 429) {
            this.show = false;
            this.LoaderStatus = false;
            const cooldown =
              otpRes.data?.data?.cooldownSeconds ??
              otpRes.data?.data?.retryAfter ??
              60;
            this.retryAfter = cooldown >= 60 ? cooldown : 60;
            this.otpSent = true;
            this.otpExceeded = true;
            if (this.retryAfter) {
              this.timerOut = true;
              this.startTimer();
            }
            if (!resend && this.userType !== "candidate") this.mode = "otp";
          } else {
            this.show = false;
            this.LoaderStatus = false;
            this.sendOtpError = "Failed to send OTP. Please try again.";
            setTimeout(() => {
              this.sendOtpError = "";
            }, 5000);
          }
        } catch (error) {
          this.show = false;
          this.LoaderStatus = false;
          const status = error.response && error.response.status;
          const errData =
            error.response && error.response.data && error.response.data.data;
          const rawDetail = errData && errData.Detail;
          const msg =
            rawDetail && rawDetail.length <= 120
              ? rawDetail
              : "Failed to send OTP. Please try again.";
          if (status == 429) {
            const cooldown =
              errData?.cooldownSeconds ?? errData?.retryAfter ?? 60;
            this.retryAfter = cooldown >= 60 ? cooldown : 60;
            this.otpSent = true;
            this.otpExceeded = true;
            if (this.retryAfter) {
              this.timerOut = true;
              this.startTimer();
            }
            if (!resend && this.userType !== "candidate") this.mode = "otp";
          } else {
            if (status == 409) this.candExists = true;
            this.sendOtpError = msg;
            setTimeout(() => {
              this.sendOtpError = "";
            }, 5000);
          }
        }
      }
    },

    async handleRegister(resend) {
      await this.register(resend);
    },

    async forgotPassword(val) {
      if (val === "resend") {
        this.clearOtp();
      }
      const useEmailForForgot = this.useEmail || this.userType !== "candidate";
      if (!val) {
        if (useEmailForForgot) {
          if (this.$refs.candmail) this.$refs.candmail.blur();
          this.$v.email.$touch();
          if (this.$v.email.$invalid) return;
        } else {
          if (this.$refs.phoneInput) this.$refs.phoneInput.blur();
          this.$v.loginPhone.number.$touch();
          if (this.$v.loginPhone.number.$invalid || this.loginPhoneInvalid)
            return;
        }
      }

      let fullPhone = "";
      if (!useEmailForForgot) {
        const dialCode = this.loginPhoneCountryCode.startsWith("+")
          ? this.loginPhoneCountryCode
          : "+" + this.loginPhoneCountryCode;
        fullPhone = dialCode + this.loginPhone.number;
      }

      this.show = true;
      this.LoaderStatus = true;
      try {
        if (!val) {
          let userdata = { type: "reset-password" };
          if (useEmailForForgot) {
            userdata.email = this.email.trim();
          } else {
            const dialCode = this.loginPhoneCountryCode.startsWith("+")
              ? this.loginPhoneCountryCode
              : "+" + this.loginPhoneCountryCode;
            userdata.countryCode = dialCode;
            userdata.phoneNumber = this.loginPhone.number.replace(/\D/g, "");
          }
          this.$store.commit("userVUEX/setUserData", userdata);
        }
        // Build payload — on resend, userData may be cleared after reset-password.
        // Always prefer live component state, fall back to userData.
        let payload = { type: "reset-password" };
        if (!val) {
          if (useEmailForForgot) {
            payload.email = this.email.trim();
          } else {
            const dialCode = this.loginPhoneCountryCode.startsWith("+")
              ? this.loginPhoneCountryCode
              : "+" + this.loginPhoneCountryCode;
            payload.countryCode = dialCode;
            payload.phoneNumber = this.loginPhone.number.replace(/\D/g, "");
          }
        } else {
          if (useEmailForForgot) {
            payload.email = this.email.trim() || this.userData.email;
          } else {
            const dialCode = this.loginPhoneCountryCode.startsWith("+")
              ? this.loginPhoneCountryCode
              : "+" + this.loginPhoneCountryCode;
            payload.countryCode = dialCode || this.userData.countryCode;
            payload.phoneNumber =
              (this.loginPhone.number || "").replace(/\D/g, "") ||
              this.userData.phoneNumber;
          }
        }
        const response = await sendOtp(payload);
        if (response.status == 200 || response.status == 429) {
          if (response.status == 429) this.otpExceeded = true;
          this.clearTimer();
          this.timerOut = false;
          this.retryAfter =
            response.status == 429
              ? response.data.data.cooldownSeconds
              : response.data.data.retryAfter;
          this.show = false;
          this.LoaderStatus = false;
          if (this.retryAfter) {
            this.timerOut = true;
            this.startTimer();
          }
          if (!val) {
            if (this.userType === "candidate") {
              this.setPasswordMode = true;
              this.isResetPasswordMode = true;
              this.showSetPasswordOtp = true;
            } else {
              this.mode = "forgotOtp";
            }
          }
        } else {
          this.show = false;
          this.LoaderStatus = false;
          this.setNoAccess(
            this.useEmail
              ? "This email ID is not registered with Hire3x."
              : "This phone number is not registered with Hire3x.",
          );
        }
      } catch (error) {
        this.show = false;
        this.LoaderStatus = false;
        if (error.response && error.response.status == 429) {
          this.otpExceeded = true;
          this.clearTimer();
          this.timerOut = false;
          this.retryAfter = error.response.data.data.cooldownSeconds;
          if (this.retryAfter) {
            this.timerOut = true;
            this.startTimer();
          }
          if (!val) {
            if (this.userType === "candidate") {
              this.setPasswordMode = true;
              this.isResetPasswordMode = true;
              this.showSetPasswordOtp = true;
            } else {
              this.mode = "forgotOtp";
            }
          }
        } else {
          this.setNoAccess(
            this.useEmail
              ? "This email ID is not registered with Hire3x."
              : "This phone number is not registered with Hire3x.",
          );
        }
      }
    },

    async sendOTP(val) {
      await this.forgotPassword(val);
    },

    async resetPasswordOTP() {
      this.verifyotp = true;
      if (this.userType === "candidate") {
        if (this.$v.otpCode.$invalid) {
          this.$v.otpCode.$touch();
          return;
        }
        this.show = true;
        this.LoaderStatus = true;
        this.verifyotp = false;
        let otpVal = this.otpCode;
        let payload = this.userData;
        payload.otp = Number(otpVal);
        try {
          const response = await checkCandOtp(payload);
          if (response.status == 200) {
            this.$store.commit("userVUEX/setUserData", {});
            this.$store.commit("userVUEX/setUserData", payload);
            await this.resetPassword();
          } else if (response.status == 400) {
            this.show = false;
            this.LoaderStatus = false;
            this.setNoAccess("OTP didn't match");
            this.clearOtp();
          } else {
            this.show = false;
            this.LoaderStatus = false;
            this.setNoAccess("Something went wrong!");
            this.clearOtp();
          }
        } catch (error) {
          this.show = false;
          this.LoaderStatus = false;
          const msg =
            error.response && error.response.data && error.response.data.data
              ? error.response.data.data.Detail
              : "Something went wrong!";
          this.setNoAccess(msg);
          this.clearOtp();
        }
      } else {
        this.$v.otpDigits.$touch();
        if (
          !this.$v.otpDigits.num1.$invalid &&
          !this.$v.otpDigits.num2.$invalid &&
          !this.$v.otpDigits.num3.$invalid &&
          !this.$v.otpDigits.num4.$invalid &&
          !this.$v.otpDigits.num5.$invalid &&
          !this.$v.otpDigits.num6.$invalid
        ) {
          this.show = true;
          this.LoaderStatus = true;
          this.verifyotp = false;
          let otpVal = `${this.otpDigits.num1}${this.otpDigits.num2}${this.otpDigits.num3}${this.otpDigits.num4}${this.otpDigits.num5}${this.otpDigits.num6}`;
          let payload = this.userData;
          payload.otp = Number(otpVal);
          try {
            const response = await checkCandOtp(payload);
            if (response.status == 200) {
              this.$store.commit("userVUEX/setUserData", {});
              this.$store.commit("userVUEX/setUserData", payload);
              this.$nextTick(() => {
                this.LoaderStatus = false;
                this.mode = "reset";
              });
            } else if (response.status == 400) {
              this.setNoAccess("OTP didn't match");
              this.clearOtp();
            } else {
              this.setNoAccess("Something went wrong!");
              this.clearOtp();
            }
          } catch (error) {
            const msg =
              error.response && error.response.data && error.response.data.data
                ? error.response.data.data.Detail
                : "Something went wrong!";
            this.setNoAccess(msg);
            this.clearOtp();
          }
        }
      }
    },

    async resetPassword() {
      if (this.$refs.pass && typeof this.$refs.pass.blur === "function")
        this.$refs.pass.blur();
      if (this.$refs.passnew && typeof this.$refs.passnew.blur === "function")
        this.$refs.passnew.blur();
      if (
        this.$refs.setPassField &&
        typeof this.$refs.setPassField.blur === "function"
      )
        this.$refs.setPassField.blur();
      if (
        this.$refs.confirmPassField &&
        typeof this.$refs.confirmPassField.blur === "function"
      )
        this.$refs.confirmPassField.blur();

      if (this.userType === "candidate") {
        this.rePassword = this.setPassword;
        this.reConfirmpassword = this.confirmPassword;
        this.validatePassword("rePassword");
      }

      if (this.$v.rePassword.$invalid || this.validPassword) {
        this.$v.rePassword.$touch();
      } else if (this.$v.reConfirmpassword.$invalid || this.match) {
        this.$v.reConfirmpassword.$touch();
      }

      if (
        !this.$v.rePassword.$invalid &&
        !this.$v.reConfirmpassword.$invalid &&
        !this.match &&
        !this.validPassword
      ) {
        this.show = true;
        this.LoaderStatus = true;
        try {
          let payload = {
            otp: Number(this.otpCode),
            password: this.rePassword.trim(),
          };
          // Build identifier: email or phone depending on login mode
          if (this.userData.email) {
            payload.email = this.userData.email;
          } else {
            payload.countryCode = this.userData.countryCode;
            payload.phoneNumber = this.userData.phoneNumber;
          }
          const res = await resetPassword(payload);
          if (res.status == 200) {
            this.$store.commit("userVUEX/setUserData", {});
            this.show = false;
            this.LoaderStatus = false;
            this.registered = true;
            this.successText = "Password set successfully";
            // Snapshot credentials before any state reset
            const _isNewUserPasswordSetup = this.isNewUserPasswordSetup;
            const _savedPassword = this.rePassword;
            const _savedEmail = this.email;
            const _savedPhone = this.loginPhone ? this.loginPhone.number : "";
            const _savedCountryCode = this.loginPhoneCountryCode;
            const _savedUseEmail = this.useEmail;
            setTimeout(async () => {
              this.registered = false;
              this.successText = "";
              if (this.userType === "candidate") {
                if (_isNewUserPasswordSetup) {
                  // Auto-login with the newly set password (no redirect to login screen)
                  this.show = true;
                  this.LoaderStatus = true;
                  const username = _savedUseEmail
                    ? _savedEmail.trim()
                    : _savedPhone.replace(/\s+/g, "");
                  await this.loginToProjects("candidate", {
                    username,
                    password: _savedPassword,
                  });
                  return;
                }
                // Normal reset-password flow: restore identifier and go back to password login
                // Do NOT call clearData() — it resets useEmail=false synchronously,
                // which re-mounts the phone input and triggers a spurious send-otp.
                this.setPasswordMode = false;
                this.isResetPasswordMode = false;
                this.isNewUserPasswordSetup = false;
                this.showSetPasswordOtp = false;
                this.otpCode = "";
                this.setPassword = "";
                this.confirmPassword = "";
                this.password = "";
                this.rePassword = "";
                this.reConfirmpassword = "";
                this.invalidCredential = false;
                this.invalidText = "";
                this.sendOtpError = "";
                this.match = false;
                this.validPassword = false;
                this.clearTimer();
                this.timerOut = false;
                this.otpExceeded = false;
                this.mode = "login";
                this.$nextTick(() => {
                  // Show password-login screen directly (identifier already in place)
                  this.useOtp = false;
                  this.otpSent = true;
                  this.userExists = true;
                  this.hasPassword = true;
                  // Restore identifier into userData so resend OTP can find it
                  if (this.useEmail) {
                    this.$store.commit("userVUEX/setUserData", {
                      email: this.email,
                    });
                  } else {
                    const dialCode = this.loginPhoneCountryCode.startsWith("+")
                      ? this.loginPhoneCountryCode
                      : "+" + this.loginPhoneCountryCode;
                    this.$store.commit("userVUEX/setUserData", {
                      countryCode: dialCode,
                      phoneNumber: this.loginPhone
                        ? this.loginPhone.number.replace(/\D/g, "")
                        : "",
                    });
                  }
                  this.$v.$reset();
                });
              } else {
                this.clearData();
                this.mode = "login";
              }
            }, 3000);
          } else {
            this.show = false;
            this.LoaderStatus = false;
            this.setFailurePopup("Password reset failed");
          }
        } catch (error) {
          this.show = false;
          this.LoaderStatus = false;
          const detailMsg =
					error.response && error.response.data && error.response.data.data
						? error.response.data.data.Detail
						: "Password reset failed";
				this.setFailurePopup(detailMsg);
        }
      }
    },

    async handleSubmit() {
      if (this.$refs.candmail && typeof this.$refs.candmail.blur === "function")
        this.$refs.candmail.blur();
      if (this.$refs.candpass && typeof this.$refs.candpass.blur === "function")
        this.$refs.candpass.blur();
      if (
        this.$refs.phoneInput &&
        typeof this.$refs.phoneInput.blur === "function"
      )
        this.$refs.phoneInput.blur();
      if (this.$refs.candotp && typeof this.$refs.candotp.blur === "function")
        this.$refs.candotp.blur();

      let flag = this.userType;

      if (this.setPasswordMode) {
        this.$v.setPassword.$touch();
        this.$v.confirmPassword.$touch();
        if (
          this.$v.setPassword.$invalid ||
          this.$v.confirmPassword.$invalid ||
          this.match
        )
          return;
        this.$v.otpCode.$touch();
        if (this.$v.otpCode.$invalid) return;
        if (this.isResetPasswordMode) {
          await this.resetPasswordOTP();
        } else {
          await this.registerCandidate();
        }
        return;
      }

      if (flag === "candidate") {
        if (this.useOtp) {
          if (!this.otpSent) {
            await this.register();
          } else {
            this.$v.otpCode.$touch();
            if (this.$v.otpCode.$invalid) return;
            if (this.userExists === false) {
              await this.registerCandidate();
            } else {
              await this.login();
            }
          }
        } else {
          await this.login();
        }
      } else {
        await this.login();
      }
    },

    // ─── Email existence check ────────────────────────────────────────────────
    debouncedCheckEmail: debounce(function () {
      this.checkEmailExistsLocal();
    }, 500),
    async checkEmailExistsLocal() {
      try {
        const res = await checkCandidateDirect({ email: this.regForm.email });
        if (res.status == 200) {
          this.emailExists = res.data.data?.isCandidateValid;
          //this.emailExists = !res.data.data?.isCandidateValid;
        }
      } catch (error) {
        console.error(error);
      }
    },

    // ─── Initialize phone number input ────────────────────────────────────────────────
    initializeTel() {
      this.$nextTick(() => {
        let inputs = [];
        const els = document.querySelectorAll("#candidatePhone");
        els.forEach((el) => {
          inputs.push(el);
        });

        if (inputs.length === 0) {
          let inputComponent = this.$refs.phoneInput;
          if (Array.isArray(inputComponent)) {
            inputComponent.forEach((c) => {
              if (c && c.$el) inputs.push(c.$el);
              else if (c) inputs.push(c);
            });
          } else if (inputComponent) {
            if (inputComponent.$el) inputs.push(inputComponent.$el);
            else inputs.push(inputComponent);
          }
        }

        if (this.itis && Array.isArray(this.itis)) {
          this.itis.forEach((iti) => iti.destroy());
        }
        this.itis = [];

        inputs.forEach((input) => {
          if (!input) return;
          const iti = intlTelInput(input, {
            utilsScript:
              "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/19.5.3/js/utils.js",
            showSelectedDialCode: true,
            nationalMode: false,
            initialCountry: "IN",
            autoPlaceholder: "off",
          });
          this.itis.push(iti);

          const initialDialCode = iti.getSelectedCountryData().dialCode;
          this.dialCodeLength = initialDialCode.length;
          this.loginPhoneCountryCode = "+" + initialDialCode;

          const dropdown = input.parentElement.querySelector(
            ".iti__flag-container",
          );
          if (dropdown) {
            dropdown.addEventListener("click", function () {
              const dropdownContainer = document.querySelector(
                ".iti__dropdown-content",
              );
              if (dropdownContainer) {
                const searchField =
                  dropdownContainer.querySelector(".iti__search-input");
                if (searchField) {
                  searchField.value = "";
                  const inputEvent = new Event("input", { bubbles: true });
                  searchField.dispatchEvent(inputEvent);
                }
              }
            });
          }

          input.addEventListener("countrychange", () => {
            const code = iti.getSelectedCountryData().dialCode;
            this.dialCodeLength = code.length;
            this.loginPhoneCountryCode = "+" + code;
            this.regForm.countryCode = "+" + code;

            const value = (this.loginPhone.number || "").replace(/\s+/g, "");
            const regValue = (this.regForm.phoneNumber || "").replace(
              /\s+/g,
              "",
            );

            if (code !== "91" && value) {
              this.loginPhoneInvalid = !iti.isValidNumber();
            } else if (code === "91") {
              this.loginPhoneInvalid = value
                ? !/^[6-9]\d{9}$/.test(value)
                : false;
            }

            if (
              this.regForm.countryCode !== "+91" &&
              this.regForm.phoneNumber
            ) {
              this.invalidPhone = !iti.isValidNumber();
            } else if (this.regForm.countryCode === "+91") {
              this.invalidPhone = regValue
                ? !/^[6-9]\d{9}$/.test(regValue)
                : false;
            }
          });

          input.addEventListener("input", () => {
            const code = iti.getSelectedCountryData().dialCode;
            const value = (this.loginPhone.number || "").replace(/\s+/g, "");
            const regValue = (this.regForm.phoneNumber || "").replace(
              /\s+/g,
              "",
            );

            if (code !== "91" && value) {
              this.loginPhoneInvalid = !iti.isValidNumber();
            }
            if (this.regForm.countryCode !== "+91" && regValue) {
              this.invalidPhone = !iti.isValidNumber();
            }
          });
        });
      });
    },
    destroyTel() {
      if (this.itis && Array.isArray(this.itis)) {
        this.itis.forEach((iti) => iti.destroy());
        this.itis = null;
      }
      if (this.iti) {
        this.iti.destroy();
        this.iti = null;
      }
    },
  },
};
